// Core
import { useState, useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

// Chakra imports
import { ChakraProvider, Portal, useDisclosure, useColorModeValue } from '@chakra-ui/react';

// Assets
import routes from '../routes.js';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import theme from '../theme/theme.js';
import { apiService } from '../services/ApiService';
//import { user } from 'services/Utils';

// Components
import MainPanel from '../components/Layout/MainPanel';
import PanelContainer from '../components/Layout/PanelContainer';
import PanelContent from '../components/Layout/PanelContent';
import Navbar from '../components/Navbars/Navbar.js';
//import Sidebar from 'components/Sidebar';

import BottomBar from '../components/Bottombar/Bottombar.js';
import Footer from '../components/Footer/Footer.js';

export default function Dashboard(props) {
  const { ...rest } = props;

  const [ fixed, setFixed ] = useState(false);
  const [isSidebarStack, setSidebarStack] = useState(false);

  const getRoute = () => {
    return window.location.pathname !== '/full-screen-maps';
  };

  const getActiveRoute = (routes) => {
    const activeRoute = '';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        const collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        const categoryActiveRoute = getActiveRoute(routes[i].views);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  // This changes navbar state(fixed or not)
  const getActiveNavbar = (routes) => {
    const activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].category) {
        const categoryActiveNavbar = getActiveNavbar(routes[i].views);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1) {
          if (routes[i].secondaryNavbar) {
            return routes[i].secondaryNavbar;
          }
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.category === 'account') {
        return getRoutes(prop.views);
      }
      if (prop.layout === '/') {
        return <Route path={prop.layout + prop.path} component={prop.component} key={key} routes={routes} />;
      } else {
        return null;
      }
    });
  };
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Chakra Color Mode
  return (
    <ChakraProvider theme={theme} resetCss={false}>
      <BottomBar />
      <MainPanel
        transition='unset !important'
        w={{ base: '100%' }}
        left={{ base: '0' }}
        maxWidth="1440px"
        float="unset"
        alignItems="center"
        justifyContent="center"
        m="0px auto 0 auto"
      >
        <Portal>
          <Navbar
            routes={routes}
            onOpen={onOpen}
            brandText={getActiveRoute(routes)}
            secondary={getActiveNavbar(routes)}
            fixed={fixed}
            {...rest}
          />
        </Portal>
        { getRoute() ? (
          <PanelContent>
            <PanelContainer>
              <Switch>
                {getRoutes(routes)}
                <Redirect from='/' to={routes[0].path} />
              </Switch>
            </PanelContainer>
          </PanelContent>
        ) : null}
      </MainPanel>
      <Footer />
    </ChakraProvider>
  );
}
